<div fxLayout="row" class="ps-portal-container">
  <div fxFlex fxLayoutAlign="start center" class="ps-content-status-portal">
    <span class="ps-title-large ps-portal-name">{{f.geral.controls.name.value}}</span>
    <span class="ps-reading-15" [ngClass]="{'ps-portal-status-activate': f.geral.controls.status.value === 1, 'ps-portal-status-deactivate': f.geral.controls.status.value === 0}">
      {{f.geral.controls.status.value === 1 ? 'Ativado' : 'Desativado'}}
    </span>
  </div>
  <div fxFlex fxLayoutAlign="end center" class="ps-tab-portal-content-btn">
    <a mat-stroked-button [routerLink]="['/administrativo/home']">Sair</a>
    <button 
      mat-raised-button 
      mat-button
      *ngIf="f.geral.controls.status.value === 1"
      (click)="viewProcess()"
      >Visualizar</button>
    <button
      (click)="changeStatusPortal()"
      matTooltipClass="ps-tooltip-content"
      mat-raised-button
      [disabled]="!formulario.valid || validationDomain"
      [ngClass]="{'ps-portal-button-status-deactivate': f.geral.controls.status.value === 1,'ps-portal-button-status-activate': f.geral.controls.status.value === 0}">
      {{f.geral.controls.status.value === 1 ? 'Desativar portal': 'Ativar portal'}}
    </button>
  </div>
</div>
<mat-card [style.margin-bottom.px]="20">
  <mat-tab-group
    #tabGroup
    dynamicHeight
    class="ps-tab-portal"
    (selectedTabChange)="tabOverflow($event)">
      <mat-tab>
        <ng-template mat-tab-label>
          <div [modificationFormAlert]="{status: formulario.controls.geral, tab: tabGroup}"></div>
          <span>Geral</span>
        </ng-template>
        <form [formGroup]="formulario">
          <app-general-portal [formGeneral]="formulario.controls.geral" [formulario]="formulario"></app-general-portal>
        </form>
      </mat-tab>
      <mat-tab [disabled]="!disableVI">
        <ng-template mat-tab-label>
          <span class="ps-tab-portal-load" *ngIf="!disableVI">
            Carregando
            <mat-spinner [diameter]="15" [strokeWidth]='1'></mat-spinner>
          </span>
          <span *ngIf="disableVI">Identidade visual</span>
        </ng-template>
        <form [formGroup]="formulario">
          <app-visual-identity-portal [formVisualIdentity]='formulario.controls.identidadeVisual' [activeTabIndex]="currentTabIndex">
          </app-visual-identity-portal>
        </form>
      </mat-tab>
      <mat-tab [disabled]="!disableDO">
        <ng-template mat-tab-label>
          <div [modificationAlert]="validationDomain" *ngIf="disableDO"></div>
          <span class="ps-tab-portal-load" *ngIf="!disableDO">
            Carregando
            <mat-spinner [diameter]="15" [strokeWidth]='1'></mat-spinner>
          </span>
          <span *ngIf="disableDO">
            Domínio
          </span>
        </ng-template>
        <form [formGroup]="formulario">
          <app-domain-portal [formDomain]="formulario.controls.dominio"></app-domain-portal>
        </form>
      </mat-tab>
      <mat-tab [disabled]="!disableTBC">
        <ng-template mat-tab-label>
          <div [modificationFormLoadAlert]="{status: formulario.controls.tbc, load: disableTBC, tab: tabGroup}">
          </div>
          <span class="ps-tab-portal-load" *ngIf="!disableTBC">
            Carregando
            <mat-spinner [diameter]="15" [strokeWidth]='1'></mat-spinner>
          </span>
          <span *ngIf="disableTBC">
            TBC
          </span>
        </ng-template>
        <form [formGroup]="formulario">
          <app-tbc-portal [formTbc]="formulario.controls.tbc"></app-tbc-portal>
        </form>
      </mat-tab>
      <mat-tab [disabled]="!disablePS">
        <ng-template mat-tab-label>
          <div [modificationFormLoadAlert]="{status: formulario.controls.processoSeletivo, load: disablePS, tab: tabGroup}"></div>
          <span class="ps-tab-portal-load" *ngIf="!disablePS">
            Carregando
            <mat-spinner [diameter]="15" [strokeWidth]='1'></mat-spinner>
          </span>
          <span *ngIf="disablePS">
            Processos em aberto
          </span>
        </ng-template>
        <app-selective-processes-portal
          [tabGroup]="tabs"
          [formSelectiveProcesses]="formulario.controls.processoSeletivo"
          [formulario]="formulario">
        </app-selective-processes-portal>
      </mat-tab>
      <mat-tab [disabled]="!disablePS">
        <ng-template mat-tab-label>
          <div
            [modificationFormLoadAlert]="{status: formulario.controls.portalQueries, load: true, tab: tabGroup}">
          </div>
          <span class="ps-tab-portal-load" *ngIf="!disablePS">
            Carregando
            <mat-spinner [diameter]="15" [strokeWidth]='1'></mat-spinner>
          </span>
          <span *ngIf="disablePS">
            Consultas
          </span>
        </ng-template>
        <app-portal-queries [formPortalQueries]="formulario.controls.portalQueries" [tbcData]="formulario.controls.tbc"></app-portal-queries>
      </mat-tab>
      <mat-tab [disabled]="!disablePS">
        <ng-template mat-tab-label>
          <div
            [modificationFormLoadAlert]="{status: formulario.controls.portalQueries, load: true, tab: tabGroup}">
          </div>
          <span class="ps-tab-portal-load" *ngIf="!disablePS">
            Carregando
            <mat-spinner [diameter]="15" [strokeWidth]='1'></mat-spinner>
          </span>
          <span *ngIf="disablePS">
            Scripts
          </span>
        </ng-template>
        <app-script-config-portal></app-script-config-portal>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="ps-tab-system-setting-label-tab">Integrações</span>
        </ng-template>
        <app-integrations-portal></app-integrations-portal>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="ps-tab-system-setting-label-tab">Segurança</span>
        </ng-template>
        <app-security></app-security>
      </mat-tab>
  </mat-tab-group>
</mat-card>
<!-- <app-form-debug [form]="formulario"></app-form-debug> -->
